import { render } from "./RiepilogoMensileRid.vue?vue&type=template&id=4b61b699"
import script from "./RiepilogoMensileRid.vue?vue&type=script&lang=js"
export * from "./RiepilogoMensileRid.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__